import React from 'react';
import { Card, CardContent, CardHeader, Stack, Typography } from '@mui/material';
import { translate as t } from 'hooks/useTranslations';
import { useEisRuleDetailsContext } from '../../context';
import DetailList from '_lex/_atoms/DetailList';
import PhxBadge from '_lex/_atoms/PhxBadge';

export default function RuleDetails() {
  const { rule } = useEisRuleDetailsContext();

  const formatTemplateSource = () => {
    if (!rule?.templates || rule.templates.length === 0) {
      return '--';
    }
    const firstTemplate = rule.templates[0];
    const remainingCount = rule.templates.length - 1;
    if (remainingCount > 0) {
      return (
        <Stack
          direction='row'
          spacing={1}
          alignItems='center'
        >
          <Typography variant='bodySm'>{firstTemplate.name}</Typography>
          <PhxBadge
            color='default'
            size='sm'
          >
            +{remainingCount}
          </PhxBadge>
        </Stack>
      );
    }
    return firstTemplate.name;
  };

  const formatThreshold = () => {
    if (!rule?.activeVersion || rule.activeVersion.thresholdPoints === null || rule.activeVersion.thresholdPoints === undefined) {
      return '--';
    }
    return `${rule.activeVersion.thresholdPoints} pts`;
  };

  const formatTimeWindow = () => {
    if (!rule?.activeVersion || !rule.activeVersion.windowType) {
      return '--';
    }
    if (rule.activeVersion.windowType === 'YearToDate') {
      return t('performanceReporting.eis.list.windowType.YTD');
    }
    if (rule.activeVersion.windowDays == null) {
      return '--';
    }
    return `${rule.activeVersion.windowDays} ${t('performanceReporting.eis.list.windowType.RollingDays')}`;
  };

  const formatFlags = () => {
    if (rule?.versionStatus === 'Draft') {
      return '--';
    }
    if (rule?.flagsCount === undefined || rule.flagsCount === null) {
      return '--';
    }
    return rule.flagsCount.toString();
  };

  const formatStatus = () => {
    if (!rule?.versionStatus) {
      return '--';
    }
    const status = rule.versionStatus;
    const statusKey = status.toUpperCase();
    let color: 'success' | 'error' | 'default' = 'default';
    if (status === 'Active') color = 'success';
    else if (status === 'Draft') color = 'default';
    else if (status === 'Inactive') color = 'error';

    return (
      <PhxBadge
        color={color}
        size='sm'
      >
        {t(`performanceReporting.eis.list.status.${statusKey}`) || status}
      </PhxBadge>
    );
  };

  const ruleDetailsItems = [
    {
      label: t('performanceReporting.eis.details.fields.ruleName'),
      value: rule?.name || '--',
    },
    {
      label: t('performanceReporting.eis.details.fields.templateSource'),
      value: formatTemplateSource(),
    },
    {
      label: t('performanceReporting.eis.details.fields.description'),
      value: rule?.description || '--',
    },
    {
      label: t('performanceReporting.eis.details.fields.groups'),
      value: '--',
    },
    {
      label: t('performanceReporting.eis.details.fields.threshold'),
      value: formatThreshold(),
    },
    {
      label: t('performanceReporting.eis.details.fields.timeWindow'),
      value: formatTimeWindow(),
    },
    {
      label: t('performanceReporting.eis.details.fields.status'),
      value: formatStatus(),
    },
    {
      label: t('performanceReporting.eis.details.fields.flags'),
      value: formatFlags(),
    },
  ];

  return (
    <Stack spacing={12}>
      <Card className='lex-card'>
        <CardHeader title={t('performanceReporting.eis.details.sections.ruleDetails')} />
        <CardContent>
          <DetailList items={ruleDetailsItems} />
        </CardContent>
      </Card>
    </Stack>
  );
}

